import React from 'react'
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import moment, { Moment } from 'moment'
import TrafficGraph from '../TrafficGraph'
import SimpleLoader from '../SimpleLoader'
import { TServiceDetail, TServiceGraphHistory } from '../../types/serviceView'

type TGraphDateRangeHandler = NonNullable<
    React.ComponentProps<typeof TrafficGraph>['dateRangeHandler']
>

type TProps = {
    service: TServiceDetail
    selectedGraphId: string
    onGraphChange: (graphId: string) => void
    graphHistory: TServiceGraphHistory | null
    graphLoading: boolean
    graphError: string
    graphStartDate: Moment
    graphEndDate: Moment
    onGraphDateRangeChange: TGraphDateRangeHandler
}

const ServiceGraphPanel: React.FC<TProps> = ({
    service,
    selectedGraphId,
    onGraphChange,
    graphHistory,
    graphLoading,
    graphError,
    graphStartDate,
    graphEndDate,
    onGraphDateRangeChange,
}) => {
    if (!service.graphs.length) {
        return null
    }

    const selectedGraph = service.graphs.find(
        (graph) => graph.id === selectedGraphId
    )

    return (
        <Card className="service-detail-card shadow-sm border-0 mt-4">
            <CardBody>
                <Row className="align-items-end mb-3">
                    <Col lg={6}>
                        <div className="service-detail-card__title mb-0">
                            Live graph
                        </div>
                    </Col>
                    {service.graphs.length > 1 ? (
                        <Col lg={5}>
                            <FormGroup className="mb-0">
                                <Label for="service-graph-selector">
                                    Graph
                                </Label>
                                <Input
                                    id="service-graph-selector"
                                    type="select"
                                    value={selectedGraphId}
                                    onChange={(event) =>
                                        onGraphChange(event.target.value)
                                    }
                                >
                                    {service.graphs.map((graph) => (
                                        <option
                                            key={graph.id}
                                            value={graph.id}
                                        >
                                            {graph.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                    ) : null}
                </Row>
                <SimpleLoader loading={graphLoading}>
                    {graphError ? (
                        <Card className="shadow-sm border-0">
                            <CardBody className="text-danger">
                                {graphError}
                            </CardBody>
                        </Card>
                    ) : null}
                    {!graphError && graphHistory && !graphHistory.empty ? (
                        <TrafficGraph
                            name={selectedGraph?.label}
                            loading={graphLoading}
                            dateRangeHandler={onGraphDateRangeChange}
                            startDate={graphStartDate}
                            endDate={graphEndDate}
                            dataIn={graphHistory.dataIn}
                            dataOut={graphHistory.dataOut}
                            unit={selectedGraph?.unit}
                        />
                    ) : null}
                    {!graphError && (!graphHistory || graphHistory.empty) ? (
                        <Card className="shadow-sm border-0">
                            <CardBody>
                                No graph history available for{' '}
                                {moment(graphStartDate).format('DD/MM/YYYY')}.
                            </CardBody>
                        </Card>
                    ) : null}
                </SimpleLoader>
            </CardBody>
        </Card>
    )
}

export default ServiceGraphPanel
